module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Thin.woff?0f080c40c639962e1cad093aa58192dc";